import TeamPage from "./TeamPage";

export default [{ path: "/team", element: <TeamPage /> }];
